(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pf-card-alt-img"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__pfCardAlt) return;
    window.__pfCardAlt = true;
    if (!window.matchMedia || !matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    function arm(e) {
      var card = e.target && e.target.closest ? e.target.closest('.pf-card--product') : null;
      if (!card) return;
      var img = card.querySelector('img.pf-card__img--alt[data-src]');
      if (!img) return;
      img.addEventListener('load', function () { img.classList.add('is-ready'); }, { once: true });
      img.srcset = img.getAttribute('data-srcset');
      img.src = img.getAttribute('data-src');
      img.removeAttribute('data-src');
      if (img.complete && img.naturalWidth) img.classList.add('is-ready');
    }
    document.addEventListener('pointerover', arm, { passive: true });
    document.addEventListener('focusin', arm);
  })();
  } catch(e) { console.error(e); }
})();

})();
